const initialStatePersonnelPosition = {
  personnel_position: [],
  update_personnel_position: false,
};

export default initialStatePersonnelPosition;